// extracted by mini-css-extract-plugin
module.exports = {"bio":"Producer_bio__D_Hsd","image":"Producer_image__icEKB","description":"Producer_description__n9eZ9"};